import React from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

import LanguageControllerContainer from 'modules/Controllers/Language/LanguageControllerContainer'
import Breadcrumbs from 'components/Breadcrumbs'

import APPURL from 'utils/app/urls'

const closeMenuOffCanvas = event => {
  document.getElementsByTagName('html')[0].classList.remove('ork-menu-off-canvas-open')
  // event.preventDefault()
}

const MenuOffCanvas = props => {
  const {
    intl: { formatMessage }
  } = props

  const url = props.history.location.pathname
  const layer = APPURL.getLayerFromURL(url)
  const language = props.match.params.lang

  this.formatMessage = formatMessage
  const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_HEAD : ''

  let classHome
  let imgSrc
  if (layer === 0) {
    classHome = 'ork-menu-off-canvas__header--home'
    imgSrc = BASE_URL + '/img/logo-observatorio-competitividad-dos-lineas-' + language + '.svg'
  } else {
    classHome = ''
    imgSrc = BASE_URL + '/img/logo-observatorio-competitividad-' + language + '.svg'
  }

  return (
    <div className="ork-menu-off-canvas">
      <div className="ork-menu-off-canvas__inner">
        <div className={`ork-menu-off-canvas__header ${classHome}`}>
          <div className="ork-menu-off-canvas__header__logo-wrapper">
            <img src={imgSrc} alt="Observatorio de competitividad" className="ork-menu-off-canvas__header__logo" />
          </div>
          <div className="ork-menu-off-canvas__header__region-wrapper">
            <span className="ork-menu-off-canvas__header__region" dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.basqueCountry) }} />
          </div>
          <a className="js-hide-menu ork-menu-off-canvas__header__close" onClick={closeMenuOffCanvas}>
            <i className="fal fa-times fa-2x" />
          </a>
        </div>
        <div className=" ork-menu-off-canvas__block">
          <div className="text-uppercase">{this.formatMessage(messages.youAreAt)}:</div>
          <Breadcrumbs responsive={true} closeMenuOffCanvas={closeMenuOffCanvas} />
        </div>
        <LanguageControllerContainer responsive={true} closeMenuOffCanvas={closeMenuOffCanvas} />
        <ul className="ork-menu-off-canvas__social-media ork-menu-off-canvas__block clearfix">
          <li>
            <a>
              <img src={BASE_URL + '/img/icono-facebook.svg'} alt="Facebook" />
            </a>
          </li>
          <li>
            <a>
              <img src={BASE_URL + '/img/icono-twitter.svg'} alt="Twitter" />
            </a>
          </li>
          <li>
            <a>
              <img src={BASE_URL + '/img/icono-linkedin.svg'} alt="LinkedIn" />
            </a>
          </li>
          <li>
            <a>
              <img src={BASE_URL + '/img/icono-youtube.svg'} alt="Youtube" />
            </a>
          </li>
          <li>
            <a>
              <img src={BASE_URL + '/img/icono-slideshare.svg'} alt="SlideShare" />
            </a>
          </li>
        </ul>
        <div className="ork-menu-off-canvas__logo-orkestra ork-menu-off-canvas__block">
          <img src={BASE_URL + '/img/logo-orkestra.svg'} alt="Orkestra: Instituto Vasco de Competitividad (Fundación Deusto)" />
        </div>
      </div>
    </div>
  )
}

export default injectIntl(MenuOffCanvas)



// WEBPACK FOOTER //
// ./src/components/MenuOffCanvas/MenuOffCanvas.js